<template>
<header>
   <div class="brand">
      <span class="title">{{ labels.title }}</span>
      <span class="sub-title">{{ labels.subTitle }}</span>
   </div>
   <nav>
      <ul>
         <!-- <li><router-link :to="{name: 'Home'}">{{ labels.home }}</router-link> |</li> -->
         <li><router-link id="map-link" :to="{name: 'Map'}">{{ labels.map }}</router-link> |</li>
         <li v-if="!isMapRoute">{{ labels.contact }} |</li>
         <li v-if="isMapRoute" id="take-a-tour"><a @click="startTour">{{ labels.tour }}</a> |</li>
         <li>
            <a id="about-link" @click="$emit('show-about')">{{ labels.about }}</a> |
         </li>
         <li
            id="language-toggler"
            @click="$emit('toggle-language')" class="flag-wrapper"
            :title="`Switch to ${this.languageIsEnglish ? 'Nepali' : 'English'} language`"
            >
            <img class="flag" :src="languageIsEnglish ? '/nepal-flag.png' : '/eng-flag.png'">
            <span class='language'> {{languageIsEnglish ? 'ने' : 'EN'}}</span>
         </li>
      </ul>
   </nav>
</header>
</template>

<script>
import { header } from '../../js/labels';
import { bus } from '../../main';

export default {
   props: {
      languageIsEnglish: { type: Boolean, required: true }
   },
   data() {
      return { header };
   },
   computed: {
      labels()
      {
         return this.languageIsEnglish ? this.header.english : this.header.nepali;
      },
      isMapRoute()
      {
         return this.$route.name==="Map";
      }
   },
   methods: {
      startTour()
      {
         bus.$emit('start-intro');
      }
   }
}
</script>

<style lang="scss" scoped>
header {
   position: relative;
   display: flex;
   justify-content: flex-end;
   align-items: flex-start;
   padding: 0.7em 2%;
   background-image: linear-gradient(to bottom, rgb(33, 94, 94), rgb(41, 109, 109));
   box-shadow: 2px 0px 3px rgb(104, 98, 98);
   min-width: 650px;
   overflow: hidden;
   
   nav ul {
      list-style: none;
      display: flex;
      align-items: center;
      color: white;
      margin: 0;

      a, li {
         color: white;
         font-size: 15px;
         margin: 0 0.5em;
         cursor: pointer;

         &.router-link-exact-active {
            color: #42b983;
         }
      }
      .language {
         color: white;
      }
   }
}

.flag-wrapper {
   display: flex;
   align-items : center;
   cursor: pointer;
   .flag {
      height: calc(18px * 0.8);
   }
   span {
      margin-top: 2px;
   }
}


.brand {
   margin-right: auto;
   letter-spacing: 0.1ch;
   margin-left: 1.6em;
   font-family: 'Montserrat';
   text-decoration: none;
   line-height: 1.8ch;
   span {
      color: #ecf0f1;
      display: block;
   }
   .title {
      cursor: pointer;
      text-transform: uppercase;
      font-size: 18px;
   }
   .sub-title {
      font-size: 12px;
   }
}

.sidebar-toggler {
   position: absolute;
   left: 1.1em;
   width: 2em;
   height: 2em;
   display: flex;
   align-items: center;
   justify-content: center;
   border-radius: 50%;
   background: rgba(255, 255, 255, 0.7);
   cursor: pointer;
   transition: 0.4s;
   z-index: 2;
}

.active-toggler {
   background: white;
}
</style>